<template>
	<el-row>
		<div style="display: flex;">
			<el-form label-position="right" label-width="100px">
				<el-form-item label="策略方案">
					{{info.planName}}
				</el-form-item>
				<el-form-item label="深耕品类">
					{{info.categoryName}}
				</el-form-item>
				<el-form-item label="期望">
					{{info.wishName}}
				</el-form-item>
				<el-form-item label="渠道代理">
					{{info.agentCount}}
				</el-form-item>
			</el-form>
			<el-form label-position="right" label-width="100px">
				<el-form-item label="用户id">
					{{info.memberId}}
				</el-form-item>
				<el-form-item label="代理人设">
					{{info.personaName}}
				</el-form-item>
				<el-form-item label="服务人群">
					{{info.memberCount}}
				</el-form-item>
				<el-form-item label="生成日期">
					{{info.created}}
				</el-form-item>
			</el-form>
		</div>
		<div style="margin-top: 20px;width: 76%;height: auto;border: 1px solid #dbdbdb;">
			<strong style="border-bottom: 1px solid #dbdbdb;
			height: 50px;text-align: center;width: 100%;display: block;height: 50px;line-height: 50px;">
				四阵地策略方案
			</strong>
			<div style="display: flex;width: 100%;height: 50px;border-bottom: 1px solid #dbdbdb;overflow-x: auto;">
				<div v-for="(item,index) in info2" :key="index" :class="chooseIndex == index ? 'box' : 'box2'"
					@click="handleSelect(item,index)">
					第{{index + 1}}天
				</div>
			</div>
			<div style="width: 500px;height: auto;">
				<div v-if="info3.trust">
					<div
						style="width: 100%;;height: 50px;;display: flex;align-items: center;justify-content: space-between;">
						<p style="color: #7b4d12;font-weight: bold;">• 构建信任</p>
						<p>{{ info3.trust.status == 0 ?'未完成':'已完成'}}</p>
					</div>
					<el-form>
						<el-form-item label="策略：">
							<div style="width: 90%;display: flex;justify-content: space-between;">
								<div style="overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.tacticsDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.tacticsTypeName}}
								</div>
							</div>
						</el-form-item>
						<el-form-item label="目标：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.targetDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.targetTask}}人/天
								</div>
							</div>
						</el-form-item>
						<el-form-item label="动作：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.sceneDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.trust.sceneTypeName}}
								</div>
							</div>
						</el-form-item>
						<div style="display: flex;align-items: center;margin: 10px;">
							<div
								style="background-color: #00bfbf;width: 40px;height: 40px;border-radius: 50px;margin-right: 10px;">
							</div>
							<div style="color: #00a1ca;">派卜推荐圈文素材</div>
						</div>
						<el-carousel indicator-position="outside" style="width: 100%;height: 400px;">
							<el-carousel-item v-for="(item,index) in info3.trust.groupMaterialVos" :key="index"
								style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<p>{{item.matInfo}}</p>
								<el-image style="width: 300px;height: 200px;" :src="item.matImg"></el-image>
							</el-carousel-item>
						</el-carousel>
					</el-form>
				</div>
				<div v-if="info3.fans">
					<div style="height: 50px;;display: flex;align-items: center;justify-content: space-between;">
						<p style="color: #7b4d12;font-weight: bold;">• 拓新吸粉</p>
						<p>{{ info3.fans.status == 0 ?'未完成':'已完成'}}</p>
					</div>
					<el-form>
						<el-form-item label="策略：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.tacticsDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.tacticsTypeName}}
								</div>
							</div>
						</el-form-item>
						<el-form-item label="目标：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.targetDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.targetTask}}人/天
								</div>
							</div>
						</el-form-item>
						<el-form-item label="动作：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.sceneDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.fans.sceneTypeName}}
								</div>
							</div>
						</el-form-item>
						<div style="display: flex;align-items: center;margin: 10px;">
							<div
								style="background-color: #00bfbf;width: 40px;height: 40px;border-radius: 50px;margin-right: 10px;">
							</div>
							<div style="color: #00a1ca;">派卜推荐商品</div>
						</div>
						<el-carousel indicator-position="outside" style="width: 100%;height: 400px;">
							<el-carousel-item v-for="(item,index) in info3.fans.festivalCommodityVos" :key="index"
								style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<el-image style="width: 300px;height: 200px;" :src="item.commodityPic"></el-image>
							</el-carousel-item>
						</el-carousel>
					</el-form>
				</div>
				<div v-if="info3.recommend">
					<div style="height: 50px;;display: flex;align-items: center;justify-content: space-between;">
						<p style="color: #7b4d12;font-weight: bold;">• 产品种草</p>
						<p>{{ info3.fans.status == 0 ?'未完成':'已完成'}}</p>
					</div>
					<el-form>
						<el-form-item label="策略：">
							<div style="width: 80%;display: flex;justify-content: space-between;">
								<div style="overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.tacticsDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.tacticsTypeName}}
								</div>
							</div>
						</el-form-item>
						<el-form-item label="目标：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.targetDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.targetTask}}人/天
								</div>
							</div>
						</el-form-item>
						<el-form-item label="动作：">
							<div style="display: flex;justify-content: space-between;">
								<div style="width: 80%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.sceneDescription}}
								</div>
								<div style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;">
									{{info3.recommend.sceneTypeName}}
								</div>
							</div>
						</el-form-item>
						<div style="display: flex;align-items: center;margin: 10px;">
							<div
								style="background-color: #00bfbf;width: 40px;height: 40px;border-radius: 50px;margin-right: 10px;">
							</div>
							<div style="color: #00a1ca;">派卜推荐圈文素材</div>
						</div>
						<el-carousel indicator-position="outside" style="width: 100%;height: 400px;">
							<el-carousel-item v-for="(item,index) in info3.recommend.groupMaterialVos" :key="index"
								style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
								<p>{{item.matInfo}}</p>
								<el-image style="width: 300px;height: 200px;" :src="item.matImg"></el-image>
							</el-carousel-item>
						</el-carousel>
					</el-form>
				</div>
				<div v-if="info3.chat">
					<div style="display: flex;align-items: center;margin: 10px;">
						<div
							style="background-color: #00bfbf;width: 40px;height: 40px;border-radius: 50px;margin-right: 10px;">
						</div>
						<div style="color: #00a1ca;">派卜推荐私聊话术案例</div>
					</div>
					<div style="width: 95%;height: auto;border: 1px solid #d7d7d7;margin: 10px auto; ">
						<div v-for="(item2,index2) in info3.chat.chatScriptVos"
							style="width: 95%;height: auto;margin: 0 auto;">
							<div v-if="item2.chatType == '01'" style="display: flex;justify-content: flex-start;">
								<div
									style="background-color: #f59a23;width: 20px;height: 20px;border-radius: 50px;align-items: center;margin: 10px;">
								</div>
								<div style="display: flex;align-items: center;">{{item2.chatContent}}</div>
							</div>
							<div v-if="item2.chatType == '02'"
								style="display: flex;justify-content: flex-end;align-items: center;">
								<div style="display: flex;align-items: center;">{{item2.chatContent}}</div>
								<div
									style="background-color: #00bfbf;width: 20px;height: 20px;border-radius: 50px;margin: 10px">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				info: [],
				info2: [],
				info3: {},
				chooseIndex: "0"
			}
		},
		methods: {
			handleSelect(item, index) {
				console.log(index);
				this.chooseIndex = index
				this.$http.post('/api/plant/plan/selectPlanOne?planId=' + this.$route.query.planId, {}).then(res => {
					this.info3 = res.data.data.dayDOList[index].scenarioDay
					console.log(this.info3);
				})
			},
			getInfo() {
				this.$http.post('/api/plant/plan/selectPlanOne?planId=' + this.$route.query.planId, {}).then(res => {
					this.info = res.data.data
					this.info2 = res.data.data.dayDOList
					this.info3 = res.data.data.dayDOList[0].scenarioDay
					console.log(this.info);
				})
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped>
	.flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.detalis .el-form {
		width: 420px;

	}

	.detalis .el-form .el-form-item {
		width: 420px;
		border-left: 1px solid #d7d7d7;
		padding-right: 10px;
	}


	.box {
		width: 100px;
		height: 100%;
		color: #fff;
		background-color: #17bfbe;
		text-align: center;
		line-height: 50px;
		margin-right: 10px;
	}

	.box2 {
		width: 100px;
		height: 100%;
		background-color: #f2f2f2;
		color: #7f7f7f;
		text-align: center;
		line-height: 50px;
		margin-right: 10px;
	}


	/deep/ .el-form {
		width: 600px;
		border: 1px solid #d7d7d7;
	}

	/deep/ .el-form:last-child {
		/* height: 163px; */
		border-left: none;
	}

	/deep/ .el-form .el-form-item {
		width: 600px;
		height: 40px;
		margin: 0;
		border-bottom: 1px solid #d7d7d7;
	}

	/deep/ .el-form .el-form-item__label {
		font-weight: bold;
		color: #000000;
	}


	/deep/ .el-form .el-form-item:last-child {
		border-bottom: none;
	}

	.list_top {
		width: 580px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #f2f2f2;
	}
</style>
